import React, { useState } from 'react'
import { EmailForm } from './EmailForm'
import { useStepper } from 'selfServicePortal/components/Stepper/use-stepper'
import { Stepper } from 'selfServicePortal/components/Stepper/stepper'
import './index.scss'
import { EmailOtp } from './EmailOtp'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { Message } from 'selfServicePortal/components/Message/Message'
import { Success } from '../Success'

interface EmailChangeProps {
	onGoBack: () => void
}

export function EmailChange({ onGoBack }: EmailChangeProps) {
	const { t } = useTranslation()
	const { stepAmount, activeStep, nextStep, prevStep, isFirstStep } =
		useStepper({
			stepAmount: 3,
			initialStep: 1,
		})
	const [sessionId, setSessionId] = useState<string>()

	return (
		<div className="email-change">
			<Stepper stepAmount={stepAmount} activeStep={activeStep} />
			<div className="back-button">
				<FontAwesomeIcon icon={faChevronLeft} />
				<button onClick={isFirstStep ? onGoBack : prevStep}>
					{t('Back')}
				</button>
			</div>

			{activeStep === 1 && (
				<EmailForm
					onSuccess={(sessionId) => {
						setSessionId(sessionId)
						nextStep()
					}}
				/>
			)}
			{activeStep === 2 && (
				<EmailOtp sessionId={sessionId} onSuccess={nextStep} />
			)}
			{activeStep === 3 && <Success onSuccess={onGoBack} />}
		</div>
	)
}
